import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=4d02e55d&"
import script from "./ProductRelated.vue?vue&type=script&lang=ts&"
export * from "./ProductRelated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports